module.exports = __webpack_public_path__ + "static/media/claim-banner.88d5069a.png";